import request from '@/utils/request'

// 字典
export function getDictByCode(dictCode) {
  return request({
    url: `/cultureCantonDemoApi/moduleDictApi/getDictByCode?dictCode=${dictCode}`,
    method: 'get',
  })
}
